import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative font-bold" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "absolute overflow-visible text-xs italic font-normal text-gray-400 whitespace-nowrap" }

import { useWrestlerStore } from '@/store/wrestlers';
import { Participant } from '@/typings/wrestler';
import { PropType, ref, computed, toRefs } from 'vue';
import Modal from '../../Modal/Modal.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  participant: {
    type: Object as PropType<Participant>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { participant } = toRefs(props);

const teamName = computed(() => {
  if (participant.value.Team) {
    return participant.value.Team.ScorecardName || participant.value.Team.Name;
  }
  return '';
});

const wrestlerStore = useWrestlerStore();

const teamMembers = computed(() => {
  if (participant.value.Team) {
    return participant.value.Team.Members.map((id) =>
      wrestlerStore.wrestlers.find((wrestler) => wrestler.SuperstarId === id)
    );
  }
  return [];
});

const membersVisible = ref(false);

function showMembers() {
  membersVisible.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(participant).Wrestler)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(participant).Wrestler.Name), 1))
        : _createCommentVNode("", true),
      (_unref(participant).Team)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "cursor-pointer hover:underline",
            onClick: showMembers
          }, _toDisplayString(_unref(teamName)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(participant).ExtraText), 1)
    ]),
    (membersVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: `Members for ${_unref(teamName)}`,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (membersVisible.value = false))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(teamMembers), (member) => {
              return (_openBlock(), _createElementBlock("div", {
                key: member?.SuperstarId
              }, _toDisplayString(member?.Name), 1))
            }), 128))
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})